// Soft-failure codes returned by POST /eligibility_check (HTTP 200 with a
// `{ code, message }` body). Mirrors Sparta's
// `sparta/src/eligibility/constants/errorCodes.ts` — kept in sync so the
// not-eligible routing decision (`shouldRouteToNotEligible`) matches the
// canonical app. Only the codes consulted by onboarding's routing are ported;
// the partner/user-endpoint explanation codes are out of scope here.
export const ELIGIBILITY_ERROR_CODES = {
  ELIGIBLE_USER_NOT_QUALIFIED: 'Eligible_User_Not_Qualified',
  ELIGIBILITY_TERMINATED: 'Eligibility_Terminated',
  ELIGIBILITY_UNDETERMINED: 'Eligibility_Undetermined',
  NOT_FOUND_PAYING_ORG: 'NotFound_PayingOrganization',
  NOT_FOUND_FN_LN_DOB_EID: 'NotFound_FN_LN_DOB_EID',
  NOT_FOUND_FN_LN_DOB: 'NotFound_FN_LN_DOB',
  NOT_FOUND_EID_DOB: 'NotFound_EID_DOB',
} as const;

export type EligibilityErrorCode =
  (typeof ELIGIBILITY_ERROR_CODES)[keyof typeof ELIGIBILITY_ERROR_CODES];
